import { create } from './schemes/create';
import { read } from './schemes/read';

export const schemes = {
  create,
  read,
};
